import React, { useEffect, useRef, useState, useContext } from "react"
import tw from "twin.macro"
import maplibregl from "maplibre-gl"
import "maplibre-gl/dist/maplibre-gl.css"
import { GeneralContext } from "../../contexts/generalContext"
import { mapStyleObj, mapStyles } from "./mapStyle"
import { storesToGeoJSON } from "./geoJSONTools"
import { phoneFormat } from "../../helpers/phoneFormat"

const StoreView = ({ store_data }) => {
  const generalContext = useContext(GeneralContext)
  const { t, lang } = generalContext
  const mapContainer = useRef(null)
  const map = useRef(null)
  const [mapLoaded, setMapLoaded] = useState(false)

  // Extraer coordenadas GPS
  const getCoordinates = () => {
    if (!store_data?.coordenadasGps) return null

    const coords = store_data.coordenadasGps.split("|")
    if (coords.length === 2) {
      return {
        lat: parseFloat(coords[0]),
        lng: parseFloat(coords[1]),
      }
    }
    return null
  }

  const coordinates = getCoordinates()

  // Inyectar estilos CSS para el mapa oscuro
  useEffect(() => {
    const styleElement = document.createElement("style")
    styleElement.textContent = mapStyles
    document.head.appendChild(styleElement)

    return () => {
      document.head.removeChild(styleElement)
    }
  }, [])

  // Inicializar el mapa
  useEffect(() => {
    if (!coordinates || map.current || !mapContainer.current) return
    const storesGeoJSON = storesToGeoJSON([store_data], null)

    map.current = new maplibregl.Map({
      container: mapContainer.current,
      style: mapStyleObj,
      center: [coordinates.lng, coordinates.lat],
      zoom: 15,
      scrollZoom: false, // Desactivar zoom con rueda del ratón
      boxZoom: false, // Desactivar zoom con selección de área
      doubleClickZoom: false, // Desactivar zoom con doble clic
      touchZoomRotate: false, // Desactivar zoom táctil en móviles
      dragPan: false, // Desactivar arrastrar el mapa
      dragRotate: false, // Desactivar rotación del mapa
      keyboard: false, // Desactivar controles de teclado
      touchPitch: false, // Desactivar pitch táctil
    })

    // Remover controles de zoom - comentar esta sección
    // map.current.addControl(new maplibregl.NavigationControl({
    //   showCompass: false,
    //   showZoom: true
    // }), 'top-right')

    // Cambiar el cursor del mapa
    map.current.getCanvas().style.cursor = "default"

    map.current.on("load", () => {
      setMapLoaded(true)

      // El estilo personalizado ya está aplicado en la configuración inicial
      map.current.addSource("stores", {
        type: "geojson",
        data: storesGeoJSON,
        cluster: false,
        clusterMaxZoom: 14, // Max zoom to cluster points on
        clusterRadius: 50, // Radius of each
      })
      map.current.addLayer({
        id: "circleOut",
        type: "circle",
        source: "stores",
        paint: {
          "circle-color": "#A99D88", // Color original para tiendas no seleccionadas
          "circle-radius": 19,
        },
      })
      map.current.addLayer({
        id: "circleIn",
        type: "circle",
        source: "stores",
        paint: {
          "circle-color": "#FFFFFF",
          "circle-radius": 15,
        },
      })
      map.current.addLayer({
        id: "storesIndex",
        type: "symbol",
        source: "stores",
        layout: {
          "text-field": "OB", // Replace with the property that contains the title
          "text-font": ["Open Sans Bold"],
          "text-size": 14,
          "text-anchor": "center",
          "text-offset": [0, 0],
          "text-justify": "center",
          "text-max-width": 16,
        },
        paint: {
          "text-color": "#474747",
          "text-halo-color": "#ffffff",
          "text-halo-width": 2,
        },
      })
    })

    // Cleanup
    return () => {
      if (map.current) {
        map.current.remove()
        map.current = null
      }
    }
  }, [coordinates])

  // Función para abrir Google Maps
  // const openInGoogleMaps = () => {
  //   if (!coordinates) return

  //   const url = `https://www.google.com/maps?q=${coordinates.lat},${coordinates.lng}`
  //   window.open(url, '_blank')
  // }

  // Función para formatear la descripción HTML
  // const formatDescription = (description) => {
  //   if (!description) return ""

  //   // Formatear HTML con estilos inline para compensar la falta de prose
  //   return description
  //     .replace(/<h3>/g, '<h3 style="color: #847360; font-weight: bold; margin: 1.5rem 0 1rem 0; font-size: 1.25rem; line-height: 1.4;">')
  //     .replace(/<\/h3>/g, '</h3>')
  //     .replace(/<p>/g, '<p style="margin: 1rem 0; line-height: 1.6;">')
  //     .replace(/<\/p>/g, '</p>')
  //     .replace(/\n/g, '<br style="margin: 0.5rem 0;">') // Convertir saltos de línea
  //     .replace(/\[...\]/g, '') // Remover [...]
  //     .replace(/<br style="margin: 0\.5rem 0;"><br style="margin: 0\.5rem 0;">/g, '<br style="margin: 1rem 0;">') // Evitar dobles br
  // }
  //onsole.log("store_data", store_data)
  return (
    <>
      <div css={tw`w-full`}>
        {/* Columnas */}
        <div css={tw`flex flex-col-reverse md:grid md:grid-cols-3 gap-0`}>
          {/* COL IZQ: Informacion de la tienda */}
          <div
            css={tw`px-4 py-6 h-full bg-white text-obmed4 text-gris1 leading-relaxed `}
          >
            <p css={tw``}>
              {store_data.direccion}
              <br />
              {store_data.codigoPostal} {store_data.localidad.title}
              {store_data.provincia.title &&
                store_data.provincia.title !== store_data.localidad.title && (
                  <span>
                    {" "}
                    ({store_data.provincia.title})
                  </span>
                )}
            </p>
            <div
            
            >
              <a
                href={`https://www.google.com/maps?q=${coordinates.lat},${coordinates.lng}`}
                target="_blank"
                rel="noopener noreferrer"
                css={tw`relative flex items-center justify-start gap-2 text-marron3 hover:text-marron2`}
              >
                {t?.storeView?.verEnMapa || "Abrir en Google Maps"}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={15}
                  height={17}
                  fill="currentColor"
                  viewBox="0 0 15 17"
                  
                >
                  <path
                    fillRule="evenodd"
                    d="M12.793 1.5h-2.2v-1h3.803v3.804h-1V2.312l-6.811 6.81-.707-.707L12.793 1.5ZM.5 3.038h7.57v1H1.5V13.5h9.462V6.93h1v7.57H.5V3.038Z"
                    clipRule="evenodd"
                  />
                </svg>
              </a>
            </div>
            <div
                css={tw`pt-6`}
            >
              <a href={`tel:${store_data.telefonoMovil}`}>
                <strong>{phoneFormat(store_data.telefonoMovil, lang)}</strong>
              </a>
            </div>
            <div>
              <a href={`mailto:${store_data.email}`}>{store_data.email}</a>
            </div>
            
          </div>

          {/* COL DER: Mapa */}
          <div css={tw`col-span-2 h-[260px] md:min-h-[350px] md:h-full`}>
            <div
              ref={mapContainer}
              css={tw`relative w-full h-full cursor-default`}
            />

            {/* Loading overlay */}
            {!mapLoaded && (
              <div
                css={tw`absolute inset-0 bg-gray-100 flex items-center justify-center`}
              >
                <div css={tw`text-center`}>
                  <div
                    css={tw`animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-2`}
                  ></div>
                  <p css={tw`text-sm text-gray-600`}>Loading...</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* {store_data.description && (
        <div css={tw`mb-8`}>
          <h2 css={tw`text-xl font-semibold text-gris1 mb-4`}>
            {t?.storeView?.sobreNosotros || "Sobre nosotros"}
          </h2>
          <div 
            css={tw`text-gris1 leading-relaxed`}
            dangerouslySetInnerHTML={{ 
              __html: formatDescription(store_data.description) 
            }}
          />
        </div>
      )}

      <div css={tw`bg-gray-50 p-6 rounded-lg`}>
        <h3 css={tw`text-lg font-semibold text-gris1 mb-3`}>
          {t?.storeView?.informacionAdicional || "Información adicional"}
        </h3>
        <div css={tw`grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gris1`}>
          {store_data.pwid && (
            <div>
              <span css={tw`font-semibold`}>ID Tienda:</span> {store_data.idstore}
            </div>
          )}
          {store_data.codigoPostal && (
            <div>
              <span css={tw`font-semibold`}>Código Postal:</span> {store_data.codigoPostal}
            </div>
          )}
          {store_data.pais_slug && (
            <div>
              <span css={tw`font-semibold`}>País:</span> {store_data.pais_slug.toUpperCase()}
            </div>
          )}
        </div>
      </div> */}
    </>
  )
}

export default StoreView
